<template>
	<div>
		<div class="row">
			<div class="col-12" v-for="(item,index) in listData" @click="listDataJump(item)">
				<div class="list_li">
					<div class="d-flex">
						<div class="left " :class="index%2==0?'order-1':'order-2'" style="padding-right:0;"><img :src="item.img" /></div>
						<div class="right flex-grow-1" :class="index%2==0?'order-2':'order-1'" style="padding-left:0;">
							<div class="cont">
								<div class="tit">{{item.tit}}</div>
								<div class="txt">{{item.txt}}</div>
							</div>
						</div>
					
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				listData: [{
						img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfaSDufv_AAEwW7DB0jc129.jpg",
						tit: '产、研、销一体化企业',
						txt: "佛山市金利高陶瓷有限公司成立于2008年，公司位于广东省佛山市，隶属于新璟盛集团。新璟盛集团是新明珠集产业链品牌，注册资金5亿元人民币，员工上万名。集团拥有多个现代化生产基地及7万多平方米的一站式提货仓，是世界具影响力的的建陶航母。 作为新璟盛集团旗下高端品牌，金利高陶瓷是一家集产品研发、生产、销售、服务于一体的现代化建陶品牌。十年来，品牌先后荣获“广东省著名商标”、“陶瓷优质产品认证”、“建材环保产品认证”、“金利高墙地砖质量太平洋保险承保证书”、“国家强制性3C产品认证”、“中国环境标志认证”、“中国十大品牌”、“佛山十大品牌”、“中国工程建设推荐品牌”等一系列荣誉。",
					},
					{
						img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfXWO31RIAAIKyFB68CM666.jpg",
						tit: '设计成就梦想',
						txt: "金利高陶瓷始终秉承“设计成就梦想”的家装理念，在产品研发上，全面引进意大利萨克米压机、多通道喷墨打印机、西斯特姆辊筒喷墨印花机,与世界一流的陶丽西、埃思玛格拉斯原材料商合作，以专业化、规模化的生产要求确保产品品质，满足大规模供货需求。产品涵盖大板、现代仿古砖、通体大理石瓷砖、喷墨抛光砖、超平釉和瓷片等品类，生产规格覆盖300x300、300x600、600x600、800x800、900x900、750x1500mm，花色品种达上千种，为消费群体提供无限的设计可能。",

					},
					{
						img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfbm8f6a_AAFc7S_zl6c151.jpg",
						tit: '匠心质造  只做最好',
						txt: " 匠心质造，臻于至善，“我们只做最好的”。金利高陶瓷建立了严格的企业内控标准，并先后通过了ISO9001质量管理体系认证、ISO14001环境管理体系认证，产品经过国家权威机构检测，放射性指标符合GB6566-2010的国家标准，属A类产品，其产销和使用范围不受限制。产品被广泛应用于各大著名建筑工程，如厦门文化中心、广西桂林机场、南开大学、北京长安街东方广场、上海大厦等。",

					},
					{
						img: "http://images02.cdn86.net/kps01/M00/7E/EB/wKiAiVwIfXWO31RIAAIKyFB68CM666.jpg",
						tit: '成功人士专属品牌',
						txt: "历经10年发展，金利高品牌营销网点遍布世界各地，产品远销欧洲、东南亚、中东等100多个国家及地区，展望未来，金利高陶瓷将时刻以世界家居建材发展需求为己任，矢志为“打造成功人士专属品牌”的梦想而不懈努力。"
					},
				],
			}
		},
		methods: {}
	}
</script>

<style scoped lang="less">
	@w: 19.2vw;
	.list_li{
		margin-top: 20/@w;
		.left{
			img{width: 500/@w;height: 500/1.5/@w;min-width: 200px;min-height:200/1.5px ;}
		}
		.right{
			.cont{
			   border: 3/@w solid #166BAB;
			   height: 100%;
			   text-align: center;
			   padding: 20/@w;
			   box-sizing: border-box;
			   height: 500/1.5/@w;
			   min-height:200/1.5px ;
			    overflow-y: scroll;
			   	 overflow:auto;
              .tit{
                   color: #A38061;           
                   font-size: 18/@w;  
                   font-weight: bold; 	
              }
              .txt{
              	color: #8A8A8A;
              	font-size: 16/@w;
              	margin-top: 5px;
              }
			}
	
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/aboutList1/index.vue